import { useAppContext } from '@contexts/app';
import { useMemo } from 'react';
import { getAccess } from './helpers';

export const useAccess = () => {
  const { primaryRole, roles } = useAppContext();
  return useMemo(() => getAccess(primaryRole, roles), [primaryRole, roles]);
};
